<template>
  <div class="col-lg-12" style="padding: 20px 30px">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">
          사용자 현황
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            아바타관리 → 사용자현황
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr 
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <td style="text-align: center">
                {{ record.s_int }}
               </td>
               <td style="text-align: center">
                {{ record.username }}
               </td>
               <td style="text-align: center">
                {{ record.name }}
              </td>
              <td style="text-align: center">
                <MyAvatarDetail :MyAvatarDetail="record" type="hair" />
              </td>
              <td style="text-align: center">
                <MyAvatarDetail :MyAvatarDetail="record" type="clothes" />
              </td>
              <td style="text-align: center">
                <MyAvatarDetail :MyAvatarDetail="record" type="weapon" />
              </td>
              <td style="text-align: center">
                <MyAvatarDetail :MyAvatarDetail="record" type="shoes" />
              </td>
              <td style="text-align: center">
                <MyAvatarDetail :MyAvatarDetail="record" type="pet" />
              </td>
              <td style="text-align: center">
                <MyAvatarDetail :MyAvatarDetail="record" type="face" />
              </td>
               <td style="text-align: center">
                {{ record.gender }}
               </td>
               <td style="text-align: center">
                {{ record.nextBoxOpen }}
               </td>

               <td>
                <MyAvatar :MyAvatar="record" :ref="'admusr' + record.id" />
                <!-- <button
                  class="btn btn-danger btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target=".bd-example-modal-list"
                  @click="GetDetail(record.id)"
                >
                상세
                </button> -->
              </td>


            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    render-button
    :callback="selectedBiz"
    :selectedNode="{ id: selData.activeBusiness }"
    ref="biz"
  />
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import Student from "../components/detail_pages/Student";
import MyAvatar from "../components/detail_pages/MyAvatar.vue";
import MyAvatarDetail from "../components/detail_pages/MyAvatarDetail.vue";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    Student,
    MyAvatar,
    QueryGrid,
    MyAvatarDetail,
  },
  props: {
    msg: String
  },
  mounted() {
    if (this.$route.query.type) {
      /*this.typeFilter = {};
        this.typeFilter[this.$route.query.type] = true;*/
      this.$refs.qg.pushSetting(
        "status_filter_" + this.$route.query.type,
        true
      );
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query.type,
      function (toQuery, previousQuery) {
        // react to route changes...

        this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_EVENT", false);
        if (toQuery)
          this.$refs.qg.pushSetting("status_filter_" + toQuery, true);

        this.$refs.qg.search();
      }
    );
  },
  methods: {
    selectedBiz(biz) {
      this.selBiz = biz;
      this.changedData.activeBusiness = biz.id;
    },
    fetchProducts(source) {
      var extras = "?";
      if (source) {
        extras += "source=" + source.id;
      }
      axios.get("/products" + extras).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.products = response.data.result;
        }
      });
    },

    fetchSubscriptions(student) {
      var extras = "";
      //this.levelRequest.record = {};
      axios
        .get('/subscriptions?status_filter=["ACTIVE"]&student=' + student.id)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            student.subscriptions = response.data.result.filter(
              (x) => x.product == "ChildU"
            );
          }
        });
    },
    addHistory() {
      var data = {
        h_date: this.hSetDate,
        DateDi: this.DateDi,
        intMemberID: this.selData.id,
      };
      var send = axios({
        method: "post",
        url: "/studies/historysave",
        data: data,
      });

      console.log(this.hSetDate);

      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$router.push(
            this.creating
              ? response.data.id.toString()
              : "../" + response.data.id.toString()
          );
        }
      });
    },
    fetchSubscriptionsChecked() {
      this.$refs.qg.checked.forEach((s) => {
        this.fetchSubscriptions(s);
      });
    },
    getDiff(value) {
      var moment = require("moment"); // moment 모듈불러오기

      const diff = moment().diff(value, "hours");
      const days = Math.floor(diff / 24);
      const hours = diff % 24;

      return -days;
    },
    getCurrent(reset, intMemberID, username, hanName, s_name, n_name) {
      //if(reset){
      this.selData = {
        id: intMemberID,
        username: username,
        hanName: hanName,
        activeBusiness: s_name,
        Business: n_name,
      };
      //console.log(this.selData)
      //}
    },
    creatingMode() {
      this.selData = {
        id: "",
        activeBusiness: "",
        username: "",
        hanName: "",
      };
      this.creating = true;
      this.changedData = {};
    },
    nvl(str) {
      if (typeof str == "undefined" || str == null) str = defaultStr;
      return str;
    },
  },
  filters: {
    currency(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  computed: {
    resultText() {
      return function(result) {
        switch (result) {
            case '0':
                return '대기';
            case '1':
                return '모듈에서 읽은 상태';
            case 'Y':
                return '발송 요청 성공';
            case 'N':
                return '발송 요청 실패';
            case '2':
                return '발송 최종 성공';
            case '4':
                return '발송 최종 실패';
            default:
                return result; // 알 수 없는 상태의 경우 기본 값 표시
        }
      }
    }
  },
  data() {
    return {
      config: {
        name: "사용자현황",
        req_endpoint: "/avatar/userList",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "아이디/이름",
          },
        ],
        columns: [
          {
            id: "s_int",
            sortable: false,
            name: "번호",
            excel_print: (v) => {
              return v.s_int;
            },
          },
          {
            id: "username",
            sortable: false,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanName",
            sortable: false,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "hair",
            sortable: false,
            name: "헤어",
            excel_print: (v) => {
              return v.hair;
            },
          },
          {
            id: "clothes",
            sortable: false,
            name: "옷",
            excel_print: (v) => {
              return v.clothes;
            },
          },

          {
            id: "weapon",
            sortable: false,
            name: "액세서리",
            excel_print: (v) => {
              return v.weapon;
            },
          },
          {
            id: "shoes",
            sortable: false,
            name: "신발",
            excel_print: (v) => {
              return v.shoes;
            },
          },
          {
            id: "pet",
            sortable: false,
            name: "펫",
            excel_print: (v) => {
              return v.pet;
            },
          },
          {
            id: "face",
            sortable: false,
            name: "얼굴",
            excel_print: (v) => {
              return v.face;
            },
          },
          {
            id: "gender",
            sortable: false,
            name: "성별",
            excel_print: (v) => {
              return v.gender;
            },
          },
          {
            id: "nextBoxOpen",
            sortable: false,
            name: "보물상자",
            excel_print: (v) => {
              return v.nextBoxOpen;
            },
          },
          {
            id: "action",
            name: "관리",
          },
        ],
        disable_init_search: true,
      },
      selBiz: {
        name: "",
      },
      subscriptions: [],
      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        hanName: "",
        Business: "",
      },
      changedData: {},
      selProduct: {},
      selectedSubscription: {
        id: 0,
      },
      products: [],
      creating: true,
    };
  },
};

</script>
